<template>
  <div class="btn-cyan">
    <a :href="url" target="_blank">
      <mdicon name="PageNextOutline" class="flex justify-center text-white" size="90" />
      <h2 class=" text-white text-2xl text-center font-semibold mb-4">{{ title }}</h2>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: 'https://fpg.duquedecaxias.rj.gov.br/fpg5/open.do?sys=FPG'
    }
  },
  props: {
    title: String
  },
}
</script>
